<template>
  <div>
    <NewOffertaPopup />
    <div class="app-main-layout" v-if="phone">
      <v-navigation-drawer v-model="navigation" app temporary overlay-color="rgb(37, 62, 119)" overlay-opacity="0.32">
        <div class="text-right mb-2">
          <v-btn large icon @click="navigation = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-tabs vertical v-if="!showRegStepper">
          <v-tab class="font" to="/cabinet/main" style="text-transform: none"> Заявки</v-tab>
          <v-tab v-if="canSeeBilling" class="font" to="/cabinet/billing" style="text-transform: none">Оплата</v-tab>
          <v-tab v-if="canSeeTeam" class="font" to="/cabinet/team" style="text-transform: none">Команда</v-tab>
          <v-tab v-if="canSeeMeetings" class="font" to="/cabinet/meeting" style="text-transform: none"
            >Открытие счета
          </v-tab>
          <v-tab v-if="canSeeManagerApps" class="font" to="/cabinet/apps" style="text-transform: none"
            >Организации</v-tab
          >
          <v-tab v-if="canSeePayouts" class="font" to="/cabinet/payouts" style="text-transform: none">Выплаты</v-tab>
          <v-tab class="font" to="/cabinet/promos" style="text-transform: none" :ripple="false" v-if="canManagePromos">
            Акции
          </v-tab>
          <v-tab
            class="font"
            to="/cabinet/bonuses"
            style="text-transform: none"
            :ripple="false"
            v-if="canSeeBilling && canSeeBonuses"
          >
            Подарки
          </v-tab>
        </v-tabs>
      </v-navigation-drawer>
      <v-app-bar app color="white" style="box-shadow: 0px 6px 20px rgba(36, 48, 54, 0.06)">
        <v-app-bar-nav-icon class="d-sm-none" @click="navigation = true" v-if="!showRegStepper"></v-app-bar-nav-icon>
        <v-tabs slider-size="5" class="navigation navigation-tabs d-none d-sm-block" v-if="!showRegStepper">
          <v-tab class="font font--h4" to="/cabinet/main" style="text-transform: none" :ripple="false"> Заявки</v-tab>
          <v-tab
            v-if="canSeeBilling"
            class="font font--h4"
            to="/cabinet/billing"
            style="text-transform: none"
            :ripple="false"
            >Оплата
          </v-tab>
          <v-tab v-if="canSeeTeam" class="font font--h4" to="/cabinet/team" style="text-transform: none" :ripple="false"
            >Команда
          </v-tab>
          <v-tab
            v-if="canSeeMeetings"
            class="font font--h4"
            to="/cabinet/meeting"
            style="text-transform: none"
            :ripple="false"
            >Открытие счета
          </v-tab>
          <v-tab
            v-if="canSeeManagerApps"
            class="font font--h4"
            to="/cabinet/apps"
            style="text-transform: none"
            :ripple="false"
            >Организации</v-tab
          >
          <v-tab
            v-if="canSeePayouts"
            class="font font--h4"
            to="/cabinet/payouts"
            style="text-transform: none"
            :ripple="false"
            >Выплаты
          </v-tab>
          <v-tab
            class="font font--h4"
            to="/cabinet/promos"
            style="text-transform: none"
            :ripple="false"
            v-if="canManagePromos"
          >
            Акции
          </v-tab>
          <v-tab
            class="font font--h4"
            to="/cabinet/bonuses"
            style="text-transform: none"
            :ripple="false"
            v-if="canSeeBilling && canSeeBonuses"
          >
            Подарки
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>

        <v-btn
          text
          :icon="$vuetify.breakpoint.xsOnly ? true : false"
          class="text-capitalize"
          :class="!$vuetify.breakpoint.xsOnly ? 'px-2' : 'px-0'"
          @click="showContactPopup(true)"
        >
          <v-icon>mdi-phone</v-icon>
          <div class="font font--h4 ml-2" v-if="!$vuetify.breakpoint.xsOnly">Контакты</div>
        </v-btn>

        <v-btn v-if="!showRegStepper" icon @click="toggleUserNotification">
          <v-badge color="primary" bordered :content="`${refreshContent}`" :value="refreshContent">
            <v-icon>mdi-message-outline</v-icon>
          </v-badge>
        </v-btn>
        <v-btn @click="toggleOptions" text icon v-if="!showRegStepper">
          <span
            class="profile-is-not-filled profile-is-not-filled--to-icon"
            v-if="(reqIsNotFilled || flNameIsNotFilled) && canSeeBilling"
          ></span>
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
        <v-btn @click="logout" text icon>
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
      </v-app-bar>

      <SidePanel v-model="showBidDetails" :title="bidDetailsTitle">
        <BidDetails :close-panel="showBidDetails" />
      </SidePanel>

      <SidePanelMeetingDetails />

      <SidePanel v-model="showBidLoadDocs" title="Загрузка документов">
        <BidLoadDoc />
      </SidePanel>

      <SidePanel :value="showNewBid" @input="toggleNewBidSidePanel" title="Новая заявка" :stateless="isNewBidEditing">
        <CabinetNewBid />
      </SidePanel>

      <SidePanel v-model="openApp" title="Компания">
        <AppSidePanel :close-panel="openApp" />
      </SidePanel>

      <SidePanel
        v-if="canSeeBilling"
        v-model="withdraw"
        title="Вывод вознаграждения"
        @sidepanelclosed="onWithdrawalClosed"
      >
        <Withdrawal v-if="!$store.state.billing.successWithdrawal" />
        <SuccessTransfer v-else />
        <template v-if="!$store.state.billing.successWithdrawal" #append>
          <!-- <v-btn @click="makeWithdraw" class="mr-3" color="primary">Подписать</v-btn> -->
          <v-btn @click="makeWithdraw" class="mr-3" color="primary" v-if="!cantWithdraw">Подписать</v-btn>
          <v-btn @click="openRequisite" class="mr-3" color="primary" v-else>{{ fillBtnText }}</v-btn>
          <v-btn @click="withdraw = false" text>Отмена</v-btn>
        </template>
      </SidePanel>

      <WittdrawalConfirmation v-if="canSeeBilling" />

      <SidePanel v-model="showNotification" title="Уведомления">
        <UserNotification @close:notification="closeNotification" />
      </SidePanel>

      <SidePanel :touchless="false" v-model="showOptions" title="Настройки">
        <CabinetOptions />
      </SidePanel>

      <MainPromoPopup v-if="!showRegStepper" />

      <!-- Перевод старых юзеров на логин - телефон -->
      <TransferPopup />
      <TransferConfirmation />

      <!-- Модалка закрытия редактирования новой заявки -->
      <v-dialog v-model="showNewBidCloseModal" persistent max-width="320">
        <v-card>
          <v-card-title class="headline">
            Закрыть окно?
          </v-card-title>
          <v-card-text
            >Вы начали создание новой заявки, но еще не отправили ее. Если закрыть окно редактирования заявки, то
            введенные данные не сохраняться.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click="closeNewBidSidePanel">
              Не сохранять
            </v-btn>
            <v-btn color="primary" text @click="closeNewBidCloseModal">
              Вернуться
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <TelegramConfirmDialog v-if="$route.query.tg_session" :telegram-session="$route.query.tg_session" />

      <v-main>
        <div class="cabinet" v-if="!requireChangePassword">
          <router-view name="append-cabinet" />

          <div :class="viewClass" class="mt-6 mt-sm-8">
            <router-view />
          </div>
        </div>
        <change-password-modal v-else />
      </v-main>

      <ContactPopup />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import "file-icon-vectors/dist/file-icon-classic.css";
import { makeRub } from "@/mixins/makeRub";
import { logout } from "@/api/login";

import SidePanelMeetingDetails from "@/components/meeting/SidePanelMeetingDetails.vue";
import TransferConfirmation from "@/components/user_transfer/TransferConfirmation.vue";
import WittdrawalConfirmation from "@/components/payment/WittdrawalConfirmation.vue";
import NewOffertaPopup from "@/components/common/popup/NewOffertaPopup.vue";
import TransferPopup from "@/components/user_transfer/TransferPopup.vue";
import UserNotification from "@/components/common/UserNotification.vue";
import SuccessTransfer from "@/components/payment/SuccessTransfer.vue";
import ContactPopup from "@/components/common/popup/ContactPopup.vue";
import CabinetOptions from "@/components/options/CabinetOptions.vue";
import MainPromoPopup from "@/components/common/MainPromoPopup.vue";
import CabinetNewBid from "@/components/bids/CabinetNewBid.vue";
import AppSidePanel from "@/components/apps/AppSidePanel.vue";
import BidDetails from "@/components/bids/BidDetails.vue";
import BidLoadDoc from "@/components/bids/BidLoadDoc.vue";
import SidePanel from "@/components/common/SidePanel";
import Rating from "@/components/bids/Rating.vue";
import Withdrawal from "@/components/Withdrawal";

export default {
  name: "CabinetLayout",

  mixins: [makeRub],

  data() {
    return {
      navigation: false,
      showNewBidCloseModal: false,
      showNotification: false,
    };
  },

  computed: {
    ...mapState({
      phone: (state) => state.profile.phone,
      refresh: (state) => state.user_notification.refresh,
    }),

    ...mapGetters("profile", [
      "reqIsNotFilled",
      "flNameIsNotFilled",
      "canSeeTeam",
      "isRegStepper",
      "canSeeBilling",
      "canSeeBonuses",
      "cantWithdraw",
      "canSeeMeetings",
      "canSeePayouts",
      "canSeeRefresh",
      "canManagePromos",
      "canSeeManagerApps",
      "waitPersonConfirm",
      "requireChangePassword",
    ]),
    ...mapGetters("billing", ["canWithdraw"]),
    ...mapGetters("common", ["loading"]),
    ...mapGetters("bid", ["isNewBidEditing"]),

    fillBtnText() {
      let text = "заполнить";
      if (this.flNameIsNotFilled && this.reqIsNotFilled) {
      } else {
        text += this.flNameIsNotFilled ? " Профиль" : this.reqIsNotFilled ? " Реквизиты" : "";
      }
      return text;
    },

    bidDetailsTitle() {
      const details = this.$store.state.bid.details;
      return details && "Заявка №" + details.num;
    },

    withdraw: {
      get() {
        return this.$store.state.billing.withdrawalSidePanel;
      },
      set(value) {
        this.$store.commit("billing/showWithdrawalSidePanel", value);
      },
    },

    showRegStepper() {
      return this.isRegStepper;
    },

    showNewBid: {
      get() {
        return this.$store.state.common.showNewBid;
      },
      set(value) {
        this.$store.commit("common/showNewBidModal", value);
      },
    },

    showOptions: {
      get() {
        return this.$store.state.common.showOptions;
      },
      set(value) {
        this.$store.commit("common/toggleOptions2", value);
      },
    },

    viewClass() {
      return {
        "pa-4": !this.showRegStepper,
        cabinet__card: !this.showRegStepper,
        "mt-8": !this.canSeeBilling,
        "mt-10 pt-10": !this.showRegStepper,
      };
    },

    showBidDetails: {
      get() {
        return this.$store.state.bid.showBidDetails;
      },
      set(value) {
        this.$store.commit("bid/set", { type: "showBidDetails", value });
      },
    },

    showBidLoadDocs: {
      get() {
        return this.$store.state.bid.showBidLoadDocs;
      },
      set(value) {
        this.$store.commit("bid/set", { type: "showBidLoadDocs", value });
      },
    },

    openApp: {
      get() {
        return this.$store.state.app.showApp;
      },
      set(value) {
        this.$store.commit("app/openAppCompany", value);
      },
    },

    refreshContent() {
      return this.refresh?.total_unreaded ? this.refresh?.total_unreaded : "0";
    },
  },

  watch: {
    showNewBid(show) {
      if (!show) {
        // очищаем стейт при закрытии окна создания заявки
        this.$store.dispatch("bid/clearNewBid");
      }
    },

    waitPersonConfirm(v) {
      if (v) {
        this.$router.push({ name: "wait-confirm" });
      }
    },
  },

  methods: {
    ...mapMutations("common", ["toggleOptions", "showContactPopup"]),
    ...mapActions(["reset"]),
    ...mapActions("user_notification", ["refreshCountBackground", "getAlerts", "refreshTime"]),

    async logout() {
      const res = await logout();
      this.reset();
    },

    openRequisite() {
      this.toggleOptions();
      if (!this.flNameIsNotFilled) {
        // Если не заполнено ФИО у физика, то заходим на первую вкладку
        this.$store.commit("common/tabShowOptions", "tab-2");
      }
    },

    makeWithdraw() {
      this.$store.dispatch("billing/makeWithdraw");
    },

    onWithdrawalClosed() {
      if (this.$store.state.billing.successWithdrawal) {
        this.$store.commit("billing/showSuccessWithdrawal", false);
      }
    },

    toggleNewBidSidePanel(v) {
      if (this.isNewBidEditing && v === false) {
        this.showNewBidCloseModal = true;
        return;
      }
      this.showNewBid = v;
    },

    toggleUserNotification(v) {
      this.showNotification = !this.showNotification;
      if (this.showNotification) {
        this.getAlerts();
      }
    },

    closeNewBidCloseModal() {
      this.showNewBidCloseModal = false;
    },

    closeNewBidSidePanel() {
      this.closeNewBidCloseModal();
      this.showNewBid = false;
    },

    closeNotification(v) {
      this.showNotification = v;
    },
  },

  components: {
    CabinetOptions,
    BidDetails,
    BidLoadDoc,
    Rating,
    CabinetNewBid,
    Withdrawal,
    SidePanel,
    WittdrawalConfirmation,
    SuccessTransfer,
    TransferPopup,
    TransferConfirmation,
    SidePanelMeetingDetails,
    UserNotification,
    NewOffertaPopup,
    AppSidePanel,
    MainPromoPopup,
    ContactPopup,
    ChangePasswordModal: () => import("@/components/common/ChangePasswordModal.vue"),
    TelegramConfirmDialog: () => import("@/components/common/TelegramConfirmDialog.vue"),
},
  async created() {
    this.$store.dispatch("reset");
    await this.$store.dispatch("profile/get");
    // проверка на право agent.background.refresh, если его нет - не вызывать
    if (this.canSeeRefresh) {
      this.refreshCountBackground();
    }
    if (this.canSeeRefresh) {
      this.refreshTime();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables";

.font--money-label {
  @media (max-width: 600px) {
    font-size: 13px;
    line-height: 16px;
  }
}

.font--big {
  @media (max-width: 600px) {
    font-weight: 500;
    font-size: 34px;
    line-height: 40px;
    letter-spacing: 0.1px;
  }
}

.navigation {
  @media screen and (min-width: 1000px) {
    margin-left: calc((100% - 960px) / 2) !important;
  }
}

.cabinet {
  max-width: 960px;
  margin: 0 auto;

  &__card {
    background-color: #ffffff;
  }

  &__withdrawal {
    background-color: #f5f5f6;
    @media (max-width: 992px) {
      padding-right: 16px;
      padding-left: 16px;
    }
  }

  &__empty {
    min-height: 350px;
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #222733;
}
</style>
